import client from '/src/services/client.js';

export default {
    getUsers : (data) => client.get(`api/users`,data),
    getUser : (id,data) => client.get(`administration/user/${id}`, data),
    addUser : (data) => client.post(`administration/user`, data),
    updateUser : (id, data) => client.put(`administration/user/${id}`, data),
    deleteUser : (id) => client.delete(`administration/user/${id}`),
    getHistories : (id,data) =>client.get(`administration/user/${id}/logs`,data),
    checkAvaibility : (data) => client.get("user/check-availability", data),
    //getUsersAutocomplete : (name) => client.get(`autocomplete/user/name?term=${name}`)
    getUsersAutocomplete : (name) => client.get(`users?username=${name}`),
    resetPassword : (id) => client.post(`administration/user/${id}/password`),
}